import mapActions from './mapActions';

export default mapActions('certification_types', {
	fetchAll_url: () => '/api/certifications/types',
	create_url: () => '/api/certifications/types',
	update_url: id => `/api/certifications/types/${id}`,
	delete_url: id => `/api/certifications/types/${id}`,
});